import { ReactNode, useEffect, useState } from 'react';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ShopifyCartDrawer } from '@/components/cart/ShopifyCartDrawer';

import { initScrollDepthTracking, resetScrollDepthForRoute } from '@/lib/crm/scrollDepth';
import { initSessionTracking } from '@/lib/eventDispatcher';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  // Cart drawer mounts after the first commit, so SSG pages hydrate without a mismatch.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  // Initialize scroll depth tracking once on mount
  useEffect(() => {
    const cleanup = initScrollDepthTracking();
    return cleanup;
  }, []);

  // Initialize session tracking (fires journey_visited once per session)
  useEffect(() => {
    initSessionTracking();
  }, []);

  // Reset scroll depth tracking on route change
  useEffect(() => {
    resetScrollDepthForRoute();
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Global SEO Structured Data (Organization, WebSite, Person) lives in index.html — single canonical @id source */}
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      {mounted && (
        <ErrorBoundary label="CartDrawer">
          <ShopifyCartDrawer />
        </ErrorBoundary>
      )}
    </div>
  );
};
